export const stripRole = (specialtyWithRole: string) => {
  const [, ...rest] = specialtyWithRole.split('-');
  return rest.join('-');
};
